/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SummarySections_change$ref = any;
export type AlertSeverity = "ERROR" | "INFO" | "SUCCESS" | "WARNING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Policy_change$ref: FragmentReference;
declare export opaque type Policy_change$fragmentType: Policy_change$ref;
export type Policy_change = {|
  +command: string,
  +databaseId: string,
  +id: string,
  +type: string,
  +alerts: $ReadOnlyArray<{|
    +path: ?string,
    +message: string,
    +severity: AlertSeverity,
  |}>,
  +availableDomains?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +databaseId: string,
        +description: string,
      |}
    |}>
  |},
  +policyHasBeenRemoved?: boolean,
  +policy?: ?{|
    +databaseId: string,
    +title: string,
    +body: string,
    +domain: ?{|
      +databaseId: string,
      +description: string,
    |},
  |},
  +$fragmentRefs: SummarySections_change$ref,
  +$refType: Policy_change$ref,
|};
export type Policy_change$data = Policy_change;
export type Policy_change$key = {
  +$data?: Policy_change$data,
  +$fragmentRefs: Policy_change$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Policy_change",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "command",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Alert",
      "kind": "LinkedField",
      "name": "alerts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "severity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "DomainConnection",
          "kind": "LinkedField",
          "name": "availableDomains",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DomainEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Domain",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "format",
                          "value": "PLAIN"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": "description(format:\"PLAIN\")"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "availableDomains(first:100)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "policyHasBeenRemoved",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policy",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "body",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Domain",
              "kind": "LinkedField",
              "name": "domain",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PolicyChange",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SummarySections_change"
    }
  ],
  "type": "DescribeChangeable",
  "abstractKey": "__isDescribeChangeable"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cff935c49c667d510c7ef85d410ea221';

module.exports = node;
